import { useAuth } from '@/hooks/useAuth';
import AuthGuard from '@/components/feature/AuthGuard';
import Navbar from '@/components/feature/Navbar';

export default function AccountsDashboard() {
  const { profile, signOut } = useAuth();

  return (
    <AuthGuard requiredRole="accounts">
      <>
        <Navbar />
        <main className="min-h-screen pt-20 pb-16 bg-background-50">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h1 className="font-heading text-2xl font-bold text-foreground-950">Accounts Dashboard</h1>
                <p className="text-sm text-foreground-500 mt-1">Welcome back, {profile?.full_name || 'Finance Team'}</p>
              </div>
              <button
                onClick={signOut}
                className="px-4 py-2 rounded-lg border border-background-300 text-foreground-600 text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                Sign Out
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-5 mb-8">
              {[
                { icon: 'ri-money-dollar-circle-line', label: 'Total Revenue', value: '₹0', color: 'bg-primary-100 text-primary-600' },
                { icon: 'ri-check-double-line', label: 'Paid Registrations', value: '0', color: 'bg-accent-100 text-accent-600' },
                { icon: 'ri-close-circle-line', label: 'Pending Payments', value: '0', color: 'bg-amber-100 text-amber-600' },
                { icon: 'ri-error-warning-line', label: 'Failed Payments', value: '0', color: 'bg-red-100 text-red-600' },
              ].map((card) => (
                <div key={card.label} className="p-5 rounded-xl border border-background-200/70 bg-background-50">
                  <div className={`w-10 h-10 rounded-lg ${card.color} flex items-center justify-center mb-3`}>
                    <i className={`${card.icon} text-lg`}></i>
                  </div>
                  <p className="text-xs text-foreground-500">{card.label}</p>
                  <p className="text-2xl font-bold text-foreground-900 mt-0.5">{card.value}</p>
                </div>
              ))}
            </div>

            <div className="rounded-2xl border border-background-200/70 bg-background-50 p-6 md:p-8">
              <h2 className="font-heading text-lg font-bold text-foreground-950 mb-2">Financial Tools</h2>
              <p className="text-sm text-foreground-500 mb-6">
                This dashboard will be fully built out in Phase 7 with payment tracking, refund management, invoicing, reconciliation, and export features.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
                {[
                  { icon: 'ri-refund-2-line', label: 'Refunds' },
                  { icon: 'ri-file-list-3-line', label: 'Invoices' },
                  { icon: 'ri-download-line', label: 'Export Excel' },
                  { icon: 'ri-file-chart-line', label: 'Revenue Reports' },
                ].map((tool) => (
                  <div key={tool.label} className="p-4 rounded-xl bg-background-100 border border-background-200/50 text-center cursor-pointer hover:bg-background-200/50 transition-colors">
                    <div className="w-10 h-10 mx-auto rounded-lg bg-background-200 flex items-center justify-center mb-2">
                      <i className={`${tool.icon} text-lg text-foreground-600`}></i>
                    </div>
                    <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">{tool.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </main>
      </>
    </AuthGuard>
  );
}